import type { AiFredSocketEvent } from "../alfred/conversation-sockets/aifred-socket-event";
import {
    type MessageSocketEvent,
    messageSocketEventTypes,
} from "../messages/socket-events/message-socket-event";
import {
    type OrderSocketEvent,
    orderSocketEventTypes,
} from "../orders/socket-events/order-socket-event";
import {
    type PaymentSocketEvent,
    paymentSocketEventTypes,
} from "../payments/socket-events/payment-socket-event";
import type { CheckInSocketEvent } from "../statuses/socket-events/check-in.socket-event";
import type { TicketSocketEvent } from "../tickets/socket-events/ticket-socket-event";

type SocketEvent =
    | OrderSocketEvent
    | PaymentSocketEvent
    | TicketSocketEvent
    | CheckInSocketEvent
    | MessageSocketEvent
    | AiFredSocketEvent;

type SocketEventType = SocketEvent["type"];
const socketEventTypes = [
    ...orderSocketEventTypes,
    ...paymentSocketEventTypes,
    ...messageSocketEventTypes,
] satisfies SocketEventType[];

export { socketEventTypes };
export type { SocketEvent, SocketEventType };
